// extracted by mini-css-extract-plugin
export default {"card":"approval-status_card__HKCEh","card--declined":"approval-status_card--declined__ZHCW5"};